/**
 * Celeste Pawn Component Factory
 *
 * Creates color-specific celeste pawn components using a factory pattern.
 * All 4 color variants (Red, Blue, Yellow, Green) are generated from
 * CelestePawnComponent with per-color gradient schemes.
 */

import React from 'react';
import type { PawnProps } from '../../constants/types';
import CelestePawnComponent from './CelestePawnComponent';
import {
  CELESTE_PAWN_COLOR_SCHEMES,
  type CelestePawnColorScheme
} from './constants/pawnColorSchemes';

type PawnColor = 'red' | 'blue' | 'yellow' | 'green';

function createCelestePawn(color: PawnColor) {
  const colorScheme: CelestePawnColorScheme = CELESTE_PAWN_COLOR_SCHEMES[color];
  const displayName = `Celeste${color.charAt(0).toUpperCase() + color.slice(1)}Pawn`;

  const ColoredPawn = React.memo(function ColoredPawn(props: PawnProps) {
    return <CelestePawnComponent {...props} colorScheme={colorScheme} />;
  });

  ColoredPawn.displayName = displayName;
  return ColoredPawn;
}

export const RedPawn = createCelestePawn('red');
export const BluePawn = createCelestePawn('blue');
export const YellowPawn = createCelestePawn('yellow');
export const GreenPawn = createCelestePawn('green');
